import { render, staticRenderFns } from "./Daily_pickup_report.vue?vue&type=template&id=6b6cf99b"
import script from "./Daily_pickup_report.vue?vue&type=script&lang=js"
export * from "./Daily_pickup_report.vue?vue&type=script&lang=js"
import style0 from "./Daily_pickup_report.vue?vue&type=style&index=0&id=6b6cf99b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports